import _ from 'underscore';
import * as Utils from 'app/blocks/common/utils';
import * as middleware from 'app/blocks/middleware/middleware';
import middlewareStatic from 'app/blocks/middleware/static';

class OrcidDataValidator {
    static validateOrcidData = async data => {
        const errors = [];
        const validData = { ...data };
        try {
            const codes = await middlewareStatic.getErrorCodes();
            if (data.firstName && !Utils.validation.validateCharacters(data.firstName)) {
                errors.push(`${codes.ORCID_VALIDATION_FIRST_NAME_INVALID}: ${data.firstName}`);
                delete validData.firstName;
            }
            if (data.lastName && !Utils.validation.validateCharacters(data.lastName)) {
                errors.push(`${codes.ORCID_VALIDATION_LAST_NAME_INVALID}: ${data.lastName}`);
                delete validData.lastName;
            }
            if (data.primaryEmailAddr && !Utils.validation.isEmailValid(data.primaryEmailAddr)) {
                errors.push(`${codes.ORCID_VALIDATION_EMAIL_INVALID}: ${data.primaryEmailAddr}`);
                delete validData.primaryEmailAddr;
            }

            if (
                data.addresses &&
                data.addresses.correspondenceAddress &&
                data.addresses.correspondenceAddress.country
            ) {
                const { country } = data.addresses.correspondenceAddress;
                // AS-6927 Countries can be named another way in ORCID, so we need to get all countries and check countryCode
                const countries = await middleware.address.getCountries('', 1000);
                if (country.countryCode && !_.findWhere(countries, { id: country.countryCode })) {
                    errors.push(
                        `${codes.ORCID_VALIDATION_INVALID_COUNTRY}: ${country.countryName} (${country.countryCode})`,
                    );
                    delete validData.addresses;
                }
            }
        } catch (error) {
            errors.push('Unexpected error occurred');
        }
        return { errors, validData };
    };
}

export default OrcidDataValidator;
